import { smoother } from "../../base/_gsap-core.js";

document.addEventListener('DOMContentLoaded', () => {
   // Button Scroll Down
   const btnScrollDown = document.querySelector('.btn-scroll-down');

   if (btnScrollDown) {
      btnScrollDown.addEventListener('click', function () {
         const currentSection = this.closest('section');
         let nextSection = currentSection?.nextElementSibling;

         while (nextSection && nextSection.tagName !== 'SECTION') {
            nextSection = nextSection.nextElementSibling;
         }

         if (nextSection) {
            smoother.scrollTo(nextSection, true);
         }
      });
   }
});
